import Vue from 'vue';
import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';

import Business from '@/models/business';
import JournalEntry from '@/models/journal-entry';
import Session from '@/models/session';
import Commission from '@/models/commission';
import File from '@/models/file';
import Protocol from '@/models/protocol';
import User from '@/models/user';

import ApplicationModule from '@/store/modules/application';
import SnackbarModule from '@/store/modules/snackbar';
import NotificationDialogModule from '@/store/modules/notification-dialog';

Vue.use(Vuex);

const database = new VuexORM.Database();

database.register(Business, {});
database.register(JournalEntry, {});
database.register(Session, {});
database.register(Commission, {});
database.register(File, {});
database.register(Protocol, {});
database.register(User, {});

export default new Vuex.Store({
  plugins: [VuexORM.install(database)],
  modules: {
    application: ApplicationModule,
    snackbar: SnackbarModule,
    notificationDialog: NotificationDialogModule,
    // Add any further modules that are not related to a vuex-orm model.
  },
});
